<section class="fixed inset-0">
  <iframe [src]="safeUrl" class="size-full"></iframe>
</section>
